export default __webpack_public_path__ + "static/media/ajman-media-city-free-zone.0ae0f65f.png";